import React from "react";
import "./memberdetail.css";
import MemberHeader from "./MemberHeader";
import logo from "../assets/icons/CDR-Logo.png";
import profile from "../assets/icons/profile1.png";
import calendarIcon from "../assets/icons/calendar.png";
import membershipIcon from "../assets/icons/crown.png";
import eventIcon from "../assets/icons/wine-glasses.png";
import spendingIcon from "../assets/icons/wallet.png";
export default function MemberDetail() {
  return (
    <>
      <MemberHeader />

      <div className="member-page">
        {/* Welcome Section */}
        <section className="welcome-section">
          <div className="welcome-left">
            <div className="member-info">
              <div className="member-photo">
                <img src={profile} alt="Member" />
              </div>
              <div className="member-details">
                <span className="welcome-text">Welcome back,</span>
                <h1>John Smith</h1>
                <p className="member-role">
                  Professional Member <span className="dot">•</span> Chevalier
                </p>
                <div className="expiry-card">
                  <img src={calendarIcon} alt="" className="calendar-icon" />
                  <span className="expiry-label">Membership Expires In</span>
                  <span className="expiry-number">184</span>
                  <span className="expiry-text">Days</span>
                </div>
              </div>
            </div>
          </div>

          {/* Member Card */}
          <div className="member-card">
            <div className="gold-line"></div>
            <div className="card-top">
              <img src={logo} alt="Logo" className="card-logo" />
              <div className="club-info">
                <h3>LA CHAÎNE DES RÔTISSEURS VIETNAM</h3>
              </div>
            </div>
            <div className="card-body">
              <div className="card-profile">
                <h2>John Smith</h2>
                <p className="role">Professional Member</p>
              </div>
            </div>
            <div className="card-footer">
              <div className="footer-row header">
                <span>Member No</span>
                <span className="divider">|</span>
                <span>Valid Until</span>
              </div>
              <div className="footer-row">
                <span>VN-2026-001</span>
                <span className="divider">|</span>
                <span>184 Days</span>
              </div>
            </div>
          </div>

          {/* Stats Grid */}
          <div className="stats-grid">
            <div className="stat-card">
              <div className="icon">
                <img src={membershipIcon} alt="Membership Status" />
              </div>
              <div>
                <p>Membership Status</p>
                <h4 className="active">Active</h4>
              </div>
            </div>

            <div className="stat-card">
              <div className="icon">
                <img src={calendarIcon} alt="Renewal Date" />
              </div>
              <div>
                <p>Renewal Date</p>
                <h4>31 Dec 2026</h4>
              </div>
            </div>

            <div className="stat-card">
              <div className="icon">
                <img src={eventIcon} alt="Events Attended" />
              </div>
              <div>
                <p>Events Attended</p>
                <h4>12</h4>
              </div>
            </div>

            <div className="stat-card">
              <div className="icon">
                <img src={spendingIcon} alt="Total Spending" />
              </div>
              <div>
                <p>Total Spending</p>
                <h4>$1,850</h4>
              </div>
            </div>
          </div>

          <div className="seat-detail-card">
            <h3 className="seat-title">My Seat Details</h3>

            <div className="seat-detail-body">
              {/* Left Side */}
              <div className="seat-left">
                <div className="seat-top">
                  <img
                    src="https://images.unsplash.com/photo-1414235077428-338989a2e8c0?w=400"
                    alt="Event"
                    className="seat-event-img"
                  />

                  <div className="seat-box">
                    <small>TABLE</small>
                    <h2>8</h2>

                    <small>YOUR SEAT</small>
                    <h1>A12</h1>
                  </div>
                </div>

                <div className="seat-bottom">
                  <div className="seat-event-info">
                    <h4>French Wine Gala Dinner</h4>
                    <p>18 Aug 2026, 7:00 PM</p>
                    <span>Sofitel Legend Metropole, Hanoi</span>
                  </div>
                </div>
              </div>

              {/* Right Side */}
              {/* <div className="seat-right">
                <h4>Seating Layout</h4>

                <div className="stage">STAGE</div>

                <div className="seat-grid">
                  <div className="seat">1</div>
                  <div className="seat">2</div>
                  <div className="seat">3</div>

                  <div className="seat">4</div>
                  <div className="seat">5</div>
                  <div className="seat">6</div>

                  <div className="seat">7</div>
                  <div className="seat active-seat">
                    8<span>A12</span>
                  </div>
                  <div className="seat">9</div>
                </div>

                <div className="seat-legend">
                  <div>
                    <span className="dot your"></span>
                    Your Seat
                  </div>

                  <div>
                    <span className="dot available"></span>
                    Available
                  </div>

                  <div>
                    <span className="dot booked"></span>
                    Booked
                  </div>
                </div>
              </div> */}
            </div>
          </div>
        </section>

        {/* Dashboard Grid */}
        <section className="dashboard-grid">
          {/* Upcoming Events */}
          <div className="dashboard-card events-card">
            <h3>Upcoming Events</h3>
            <div className="event-item">
              <div className="event-icon">🍷</div>
              <div className="event-details">
                <h4>French Wine Gala Dinner</h4>
                <p>15 August 2026, 7:00 PM</p>
                <span className="event-location">
                  Sofitel Legend Metropole, Hanoi
                </span>
              </div>
            </div>
            <div className="event-item">
              <div className="event-icon">👨‍🍳</div>
              <div className="event-details">
                <h4>Chef's Table Experience</h4>
                <p>10 September 2026, 6:30 PM</p>
                <span className="event-location">Hanoi Daewoo Hotel</span>
              </div>
            </div>
            <div className="event-item">
              <div className="event-icon">🥂</div>
              <div className="event-details">
                <h4>Champagne Night</h4>
                <p>05 October 2026, 7:30 PM</p>
                <span className="event-location">InterContinental Saigon</span>
              </div>
            </div>
            <button className="view-all-btn">View All Events</button>
          </div>

          {/* Member & Account */}
          <div className="dashboard-card account-card">
            <h3>Member & Account</h3>
            <div className="account-item">
              <span className="account-label">Member Type</span>
              <span className="account-value">Registered</span>
            </div>
            <div className="account-item">
              <span className="account-label">Grade</span>
              <span className="account-value">Book Seat</span>
            </div>
            <div className="account-item">
              <span className="account-label">Member Since</span>
              <span className="account-value">Book Seat</span>
            </div>
            <div className="account-item">
              <span className="account-label">Status</span>
              <span className="account-value status-available">Available</span>
            </div>
            <button className="view-details-btn">
              View Membership Details
            </button>
          </div>
        </section>

        {/* Bottom Section */}
        <section className="bottom-section">
          {/* My Payments */}
          <div className="bottom-card payments-card">
            <h3>My Payments</h3>
            <div className="payment-amount">
              <span className="amount">$0.00</span>
              <span className="payment-status">No outstanding payments</span>
            </div>
            <p className="payment-note">All payments are up to date.</p>
            <button className="view-btn">View Payments</button>
          </div>

          {/* My Bookings */}
          <div className="bottom-card attended-card">
            <h3>Past Events Attended</h3>

            <div className="attended-item">
              <span className="attended-icon">🍷</span>

              <div>
                <p className="attended-title">Bordeaux Wine Tasting Evening</p>
                <span className="attended-date">12 May 2026</span>
              </div>

              <span className="attended-status">Attended</span>
            </div>

            <div className="attended-item">
              <span className="attended-icon">🍽️</span>

              <div>
                <p className="attended-title">Chef's Signature Dinner</p>
                <span className="attended-date">28 March 2026</span>
              </div>

              <span className="attended-status">Attended</span>
            </div>

            <div className="attended-item">
              <span className="attended-icon">🥂</span>

              <div>
                <p className="attended-title">Champagne Celebration Night</p>
                <span className="attended-date">18 January 2026</span>
              </div>

              <span className="attended-status">Attended</span>
            </div>

            <button className="view-btn">View Event History</button>
          </div>

          {/* My Tickets */}
          <div className="bottom-card tickets-card">
            <h3>My Tickets</h3>
            <div className="ticket-actions">
              <button className="ticket-btn browse-btn">Browse Events</button>
              <button className="ticket-btn my-tickets-btn">My Tickets</button>
            </div>
          </div>

          {/* Contact Support */}
          <div className="bottom-card support-card">
            <h3>Support</h3>
            <div className="support-actions">
              <button className="support-btn download-btn">
                Download Card
              </button>
              <button className="support-btn contact-btn">
                Contact Support
              </button>
            </div>
          </div>
        </section>

        {/* Footer */}
        <footer className="page-footer">
          <p>© 2026 La Chaîne des Rôtisseurs Vietnam. All rights reserved.</p>
        </footer>
      </div>
    </>
  );
}
